import { getJssdkConfig, share } from "@/api/common";
import wx from "weixin-js-sdk"; // 引入微信SDK
import { useAgent } from '@/hooks/useAgent'
// 微信分享钩子
export const useWx = async (params) => {
    const { isWeChat } = useAgent();
    // 微信外不执行
    if (!isWeChat) return
    const {
        data: { debug, appId, timestamp, nonceStr, signature, jsApiList },
    } = await getJssdkConfig({ url: window.location.href });
    wx.config({
        debug,
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList,
    });
    const { type, guid, puid } = params;
    const {
        data: { title, desc, link, imgUrl },
    } = await share({
        type,
        guid,
        puid,
    });

    const shareData = {
        title,
        desc,
        link: params.link || link, //如果传了link就用传递过来的link  没有则用接口返回的link
        imgUrl,
        success: () => {
            console.log("初始化分享成功！");
        },
    };
    wx.ready(() => {
        wx.updateAppMessageShareData(shareData);
        wx.updateTimelineShareData(shareData);
    });

}